import { Box, styled } from '@mui/material';

import { COLORS } from '../../../configs/colors';

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  background-color: ${COLORS.BackgroundGrey};
`;

export const PageHeader = styled(Box)`
  padding: 10px 16px 0;
  background: linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%);
  color: ${COLORS.White};
`;

export const HeaderTop = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const PageTitle = styled(Box)`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.3px;
`;

export const HeaderActions = styled(Box)`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const HeaderButton = styled('button')`
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: ${COLORS.White};
  cursor: pointer;
  padding: 8px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  & svg {
    width: 20px;
    height: 20px;
  }
`;

export const FilterBadge = styled(Box)`
  position: absolute;
  top: -4px;
  right: -4px;
  background: ${COLORS.SLABreached};
  color: ${COLORS.White};
  font-size: 0.6rem;
  font-weight: 700;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border: 2px solid ${COLORS.NavyBlueDark};
`;

export const ContentCurve = styled(Box)`
  background: ${COLORS.BackgroundGrey};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  margin-top: -1px;
  position: relative;
  z-index: 2;
`;

export const ServicesList = styled(Box)`
  flex: 1;
  padding-bottom: 16px;
  overflow-x: hidden;
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: ${COLORS.Gray};
`;

export const EmptyStateText = styled(Box)`
  font-size: 14px;
  margin-top: 12px;
`;

export const SectionHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 6px;
  background: transparent;
  overflow: hidden;
`;

export const SectionTitle = styled(Box)`
  font-size: 1rem;
  font-weight: 700;
  color: ${COLORS.Black};
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: -0.2px;
`;

export const SectionCount = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  background-color: ${COLORS.NavyBlue};
  color: ${COLORS.White};
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 12px;
`;

export const ActiveFiltersDisplay = styled(Box)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 16px 8px;
`;

export const ActiveFilterChip = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px 6px 12px;
  background: linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%);
  color: ${COLORS.White};
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 600;
`;

export const ActiveFilterChipClose = styled('span')`
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    opacity: 0.7;
  }
`;

export const PullIndicator = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: height 0.2s ease;
  color: ${COLORS.NavyBlue};
  font-size: 0.75rem;
  font-weight: 600;
`;

export const ScrollSentinel = styled('div')`
  height: 1px;
  width: 100%;
`;

export const LoadingMore = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  color: ${COLORS.Gray};
  font-size: 0.8rem;
`;
